import { render, staticRenderFns } from "./AddCustom.vue?vue&type=template&id=2bfc835f&scoped=true&"
import script from "./AddCustom.vue?vue&type=script&lang=js&"
export * from "./AddCustom.vue?vue&type=script&lang=js&"
import style0 from "./AddCustom.vue?vue&type=style&index=0&id=2bfc835f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc835f",
  null
  
)

export default component.exports